import { render, staticRenderFns } from "./AddTagModal.vue?vue&type=template&id=3f2d9224&"
import script from "./AddTagModal.vue?vue&type=script&lang=ts&"
export * from "./AddTagModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VColorPicker } from 'vuetify/lib/components/VColorPicker';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VColorPicker,VForm,VLayout,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f2d9224')) {
      api.createRecord('3f2d9224', component.options)
    } else {
      api.reload('3f2d9224', component.options)
    }
    module.hot.accept("./AddTagModal.vue?vue&type=template&id=3f2d9224&", function () {
      api.rerender('3f2d9224', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tags/AddTagModal.vue"
export default component.exports